import { SanitizeFunctionType } from 'helper/sanitizer';

export default (limit: number): SanitizeFunctionType => {
	if (typeof limit !== 'number') {
		return (value: string) => value;
	}

	if (limit === 0) {
		return () => '';
	}

	return (input: string): string => {
		if (input.length > limit) {
			return input.slice(0, limit);
		}

		return input;
	};
};
